import request, { privateRequest } from "lib/request";

export const loginAPI = async (data) => {
  try {
    const response = await request.post("/api/users/login", data);
    return response.data;
  } catch (error) {
    console.error("Error while logging in", error);
    throw error;
  }
};

export const fetchCurrentUserAPI = async () => {
  try {
    const response = await privateRequest.get("/api/users/current");
    return response.data;
  } catch (error) {
    console.error("Error fetching current user:", error);
    throw error;
  }
};
